'use client';

import { forwardRef, useImperativeHandle } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { UserProfileFields } from '@/shared/ui/forms/user-profile-fields';
import { profileSchema, type ProfileFormData } from '@/shared/lib/validation/registration-wizard/profile';
import type { FormHandle } from '@/shared/ui/forms/form-handle';


type Props = {
    defaultValues?: Partial<ProfileFormData>;
    onSubmit      : (data: ProfileFormData) => void;
};


export const ProfileSubForm = forwardRef<FormHandle<ProfileFormData>, Props>(function ProfileSubForm ({ defaultValues, onSubmit }, ref) {
    const form = useForm<ProfileFormData>({
        resolver      : zodResolver(profileSchema),
        mode          : 'onBlur',
        reValidateMode: 'onChange',
        defaultValues : {
            first_name: '',
            job_title : '',
            last_name : '',
            phone     : '',
            ...defaultValues,
        },
    });

    useImperativeHandle(ref, () => ({
        submit: async () => {
            const valid = await form.trigger();
            if (!valid) return null;
            const values = form.getValues();
            onSubmit(values);
            return values;
        },
    }));

    return (
        <FormProvider { ...form }>
            <UserProfileFields/>
        </FormProvider>
    );
});
